import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faExternalLinkAlt } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { tv } from "tailwind-variants";

const styles = tv({
  slots: {
    base: "flex w-full flex-row items-center gap-30 px-30 py-15 transition-colors hover:bg-secondary-light",
    text: "transition-opacity duration-300 group-hover:line-clamp-1 group-hover:opacity-100",
    icon: "h-20",
  },
  variants: {
    isActive: {
      true: { base: "bg-secondary-light" },
    },
    isSidebarExpanded: {
      true: {
        text: "line-clamp-1 truncate opacity-100",
      },
      false: {
        text: "line-clamp-1 opacity-0",
      },
    },
  },
});

interface IProps {
  icon: IconProp;
  title: string;
  url: string;
  isExternal?: boolean;
  isNewTab?: boolean;
  isActive: boolean;
  isSidebarExpanded: boolean;
  subtitle?: string;
}

const SidebarLink = ({
  icon,
  title,
  url,
  isExternal,
  isNewTab,
  isActive,
  isSidebarExpanded,
}: IProps) => {
  const {
    base,
    text,
    icon: iconStyles,
  } = styles({ isActive, isSidebarExpanded });

  const renderItemChildren = () => (
    <>
      <FontAwesomeIcon fixedWidth icon={icon} className={iconStyles()} />
      <span className={text()}>
        {title}
        {isExternal && isNewTab && (
          <FontAwesomeIcon
            fixedWidth
            icon={faExternalLinkAlt}
            className="ml-10"
          />
        )}
      </span>
    </>
  );

  if (isExternal) {
    return (
      <a
        href={url}
        target={isNewTab ? "_blank" : "_self"}
        className={base()}
        data-testid="sidebar-menu-link">
        {renderItemChildren()}
      </a>
    );
  }

  return (
    <Link to={url} className={base()} data-testid="sidebar-menu-link">
      {renderItemChildren()}
    </Link>
  );
};

export default SidebarLink;
